import type { CustomerDetail } from './types';

/// Where the search for the account of the typed mail stands. `email` is the mail it answered
/// for: typing another one goes back to `idle`.
export type AccountLookup =
  | { status: 'idle' }
  | { status: 'searching'; email: string }
  | { status: 'found'; email: string; customer: CustomerDetail }
  | { status: 'none'; email: string }
  | { status: 'failed'; email: string };

export type CounterContactValues = { fullName: string; email: string; phone: string };

export type CounterContactErrors = Partial<Record<keyof CounterContactValues, string>>;

/// The contact can be confirmed once the search answered, or failed: a failed search must not
/// block the counter, since registering finds or creates the account anyway.
export function isLookupSettled(lookup: AccountLookup): boolean {
  return lookup.status === 'found' || lookup.status === 'none' || lookup.status === 'failed';
}

/// The words that change with what the lookup is for.
export type CounterLookupCopy = {
  emailLabel: string;
  nameLabel: string;
  foundNotice: string;
  noneNotice: string;
  failedNotice: string;
  foundNameHelper: string;
};

export const quotationLookupCopy: CounterLookupCopy = {
  emailLabel: 'Mail de quien ofrece el equipo',
  nameLabel: 'Nombre de quien ofrece el equipo',
  foundNotice:
    'Confirmá con la persona el nombre y el teléfono de esta cotización: la cotización queda en esa cuenta.',
  noneNotice:
    'Al registrar la cotización creamos una cuenta pendiente y le mandamos la invitación a',
  failedNotice:
    'No pudimos buscar la cuenta. Podés seguir igual: al registrar, usamos la cuenta de ese mail si existe o la creamos.',
  foundNameHelper: 'Queda en la cotización. Para corregir la cuenta, editala desde su ficha.',
};
